import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

// Config
import { getRoute, urls } from "../../config/routes";

// Components
import ContributorDetailPanel from "../../components/ContributorDetailPanel";
import ContributorRequests from "../../components/ContributorRequests";
import SectionWrapper from "../../components/SectionWrapper";

const ContributorDetailPage = () => {
  const history = useHistory();
  const { contributorId } = useParams();
  const { userDetails } = useSelector(s => s.user);
  const { contributors, data, isDeletingContributor, isLoadingContributors } =
    useSelector(state => state.caseDetail);

  const isCurrentUser = Boolean(userDetails) && contributorId === userDetails.id;

  const currentContributor = React.useMemo(() => {
    if (!isCurrentUser) {
      return contributors.find(item => item && item.id === contributorId);
    }

    // Prefer the real contributor record (has colorHex, etc.) over the
    // hand-built fallback below, which is missing fields like colorHex.
    const ownContributor = contributors.find(
      item => item && item.id === userDetails.id
    );

    return (
      ownContributor ||
      (data && {
        ...userDetails,
        capacity: data.userCapacity,
        invitationAccepted: true,
        profilePictureURL: userDetails.profilePhotoURL,
        isOwner: data.isOwnedByUser
      })
    );
  }, [contributorId, contributors, data, isCurrentUser, userDetails]);

  React.useEffect(() => {
    const isIntel = data && data.isIntel;
    const notInvited =
      !isCurrentUser &&
      contributors &&
      contributors.length > 0 &&
      !currentContributor;

    if (isIntel || notInvited) {
      history.push(getRoute(urls.caseDetail, { caseId: data.id }));
    }
  }, [contributors, currentContributor, data, history, isCurrentUser]);

  return (
    <SectionWrapper>
      {data && currentContributor && (
        <>
          <ContributorDetailPanel
            caseId={data.id}
            contributor={currentContributor}
            creatorId={data.creatorId}
            deleting={isDeletingContributor}
            loading={isLoadingContributors}
            userCapacity={data.userCapacity}
          />
          <ContributorRequests
            caseId={data.id}
            contributor={currentContributor}
            loading={isLoadingContributors}
          />
        </>
      )}
    </SectionWrapper>
  );
};

export default ContributorDetailPage;
